import React, { useEffect } from 'react';
import { Result } from 'antd';
import { formatValidityPeriod } from '../../../../utils/licenseUtils';
import '../LicensePrivate/LicenseView.css';

function LicenseView({ license }) {
  useEffect(() => {
    document.title = '营业执照查看';
    
    if (license?.name || license?.companyName) {
      document.title = `${license.name || license.companyName} - 营业执照`;
    }
  }, [license]);

  if (!license) {
    return (
      <Result
        status="warning"
        title="未找到营业执照信息"
        subTitle="请检查URL参数是否正确，或联系管理员获取有效链接。"
      />
    );
  }

  // 适配不同的数据结构（管理后台和公开查看可能数据结构不同）
  const licenseData = {
    name: license.name || license.companyName || '',
    number: license.number || license.creditCode || '',
    address: license.address || '',
    legalRepresentative: license.legalRepresentative || license.legalPerson || '',
    type: license.type || license.companyType || '',
    category: license.category || '',
    registeredCapital: license.registeredCapital || '',
    initialIssueDate: license.initialIssueDate || license.establishDate || '',
    validityPeriod: formatValidityPeriod(license.validityPeriod, license.initialIssueDate, 1),
    businessScope: license.businessScope || '',
    issuingAuthority: license.issuingAuthority || license.registrationAuthority || '',
    issueDate: license.issueDate || ''
  };

  return (
    <div className="container">
      <div className="top">
        <div className="top-first">
          <p className="p-first">中华人民共和国文化和旅游部</p>
        </div>
      </div>

      <div className="first">
        <span className="xd">|</span>
        <span>{licenseData.name}</span>
      </div>
      
      <div className="ycxx">
        <div className="ycxx-content">
          <div className="ycxx-left">
            <span>编号</span>
            <span>{licenseData.number}</span>
          </div>
          <div className="ycxx-left">
            <span>名称</span>
            <span>{licenseData.name}</span>
          </div>
        </div>
        
        <div className="ycxx-content">
          <div className="ycxx-left">
            <span>住所</span>
            <span>{licenseData.address}</span>
          </div>
          <div className="ycxx-left">
            <span>法定代表人</span>
            <span>{licenseData.legalRepresentative}</span>
          </div>
        </div>
        
        <div className="ycxx-content">
          <div className="ycxx-left">
            <span>类型</span>
            <span>{licenseData.type}</span>
          </div>
          <div className="ycxx-left">
            <span>单位类别</span>
            <span>{licenseData.category}</span>
          </div>
        </div>
        
        <div className="ycxx-content">
          <div className="ycxx-left">
            <span>注册资本</span>
            <span>{licenseData.registeredCapital}</span>
          </div>
          <div className="ycxx-left">
            <span>首次发证日期</span>
            <span>{licenseData.initialIssueDate}</span>
          </div>
        </div>
        
        <div className="ycxx-content">
          <div className="ycxx-left">
            <span>有效期</span>
            <span>{licenseData.validityPeriod}</span>
          </div>
          <div className="ycxx-left">
            <span>经营范围</span>
            <span>{licenseData.businessScope}</span>
          </div>
        </div>
        
        <div className="ycxx-content">
          <div className="ycxx-left">
            <span>发证机关</span>
            <span>{licenseData.issuingAuthority}</span>
          </div>
          <div className="ycxx-left">
            <span>发证日期</span>
            <span>{licenseData.issueDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LicenseView; 